import React, { useState, useContext, useEffect } from "react";
import { Images } from "../../theme";
import "./styles.css";
import { AuthContext } from "../../context/AuthContext";
import { emailRegex, DotsLoader } from "../../components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default () => {
  const AuthData = useContext(AuthContext);
  let { isLoading, handle_sign_for_news_letter } = AuthData;
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const closeEmail = () => setEmail("");

  const checkValidation = () => {
    if (!email) {
      setEmailError(t("Required_Email"));
    } else if (!email.match(emailRegex)) {
      setEmailError(t("Invalid_Email"));
    } else {
      handle_sign_for_news_letter({ email }, closeEmail);
    }
  };

  return (
    <div className="bg-white py-5 px-3">
      <div className="container">
        <p className="text-dark MontserratSemiBold text-center mt-5 mb-0 signup-head">
          {t("For_News_Letter")}
        </p>
        <p className="signup-recieve Montserrat text-16 text-center mt-3">
          {t("For_News_Letter_Information")}{" "}
          <Link to="/PrivacyPolicy">
            <label className="text-blue text-16 pointer">
              {t("Privacy_Policy")}
            </label>
          </Link>
        </p>
        <div
          style={{ width: "85%", margin: "auto" }}
          class=" input-group email-grp mt-5 mb-3"
        >
          <input
            style={{ background: "#fff" }}
            type="text"
            class="email-slid form-control MontserratSearchLast"
            placeholder={t("Email")}
            aria-label="Recipient's username"
            aria-describedby="basic-addon2"
            onChange={(e) => {
              setEmailError(false);
              setEmail(e.target.value);
            }}
          />
          <div class="input-group-append mx-3">
            <button
              disabled={isLoading}
              class="bttn btn btn-outline-secondary signup-submit"
              type="button"
              onClick={() => checkValidation()}
            >
              {isLoading ? <DotsLoader /> : t("Submit")}
            </button>
          </div>
        </div>
        <div className="error_text" style={{ width: "85%", margin: "auto" }}>
          {emailError}
        </div>
        <p className="signup-recieve Montserrat text-16 mb-5 never-txt">
          {t("Never_Share_Your_Email")}
        </p>
      </div>
    </div>
  );
};
